
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m13.4913 5.64167c.2914-.33739.8149-.33564 1.104.00367.2329.27322.2315.67544-.0031.94711l-4.67013 5.40755 4.67013 5.4076c.2346.2716.236.6738.0031.9471-.2891.3393-.8126.341-1.104.0036l-4.92681-5.7047c-.32424-.3755-.32423-.9318 0-1.3073z","fill":"#4a3428"}})])
          )
        }
      }
    